module.exports = __webpack_public_path__ + "static/media/info-button.2402fe4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info-button.png
// module id = 76
// module chunks = 1